import React, { useState } from 'react';
import {
    Container,
    Card,
    CardContent,
    Typography,
    TextField,
    Button,
    Box,
    Alert
} from '@mui/material';
import axios from 'axios';
import { API_URL } from '../../../config';
import SubTopHeader from '../../../menus/SubTopHeader';

export default function VerifyProductPage() {
    const [code, setCode] = useState('');
    const [result, setResult] = useState(null);
    const [error, setError] = useState('');

    const handleVerify = async () => {
        setError('');
        setResult(null);
        if (!code.trim()) {
            setError('Please enter a serial code.');
            return;
        }

        try {
            const res = await axios.get(API_URL + '/ac/verify_product.php', {
                params: { code }
            });
            setResult(res.data);
        } catch (e) {
            setError(e.response?.data?.error || 'Verification failed');
        }
    };

    return (
        <>
            <SubTopHeader />
            <Container maxWidth="xs" sx={{ py: 4, px: { xs: 1, sm: 3 }, mt: 5 }}>
                <Card variant="outlined" sx={{ boxShadow: 3, borderRadius: '10px' }}>
                    <CardContent sx={{ px: { xs: 1, sm: 3 }, py: { xs: 2, sm: 3 } }}>
                        <Typography
                            variant="h5"
                            component="h1"
                            align="center"
                            gutterBottom
                            sx={{ fontSize: { xs: '1.5rem', sm: '2rem' }, marginBottom: 3 }}
                        >
                            Verify Product
                        </Typography>

                        <TextField
                            label="Serial Code"
                            fullWidth
                            value={code}
                            onChange={e => setCode(e.target.value)}
                            sx={{ mb: 2 }}
                            InputProps={{
                                sx: {
                                    fontSize: { xs: '0.9rem', sm: '1.1rem' }
                                }
                            }}
                        />

                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                            <Button
                                variant="contained"
                                onClick={handleVerify}
                                size="large"
                                sx={{ px: 4 }}
                            >
                                Verify
                            </Button>
                        </Box>

                        {error && (
                            <Alert severity="error" sx={{ mt: 1 }}>
                                {error}
                            </Alert>
                        )}

                        {result && (
                            <Alert
                                severity={result.valid ? 'success' : 'warning'}
                                sx={{ mt: 1 }}
                            >
                                {result.valid
                                    ? `✔️ ${result.product_name} is genuine.`
                                    : '❌ Invalid or revoked code.'}
                            </Alert>
                        )}
                    </CardContent>
                </Card>
            </Container>
        </>
    );
}
